import * as Alert from './alert';
import { request } from './api';

/**
 * Action constants
 */
export const DIVIDENDS_REQUEST = 'DIVIDENDS_REQUEST';
export const DIVIDENDS_FETCH_SUCCESS = 'DIVIDENDS_FETCH_SUCCESS';
export const DIVIDENDS_FETCH_FAIL = 'DIVIDENDS_FETCH_FAIL';
export const DIVIDENDS_CLEAR = 'DIVIDENDS_CLEAR';
export const DIVIDENDS_SET_SELECTED_ACCOUNTS =
  'DIVIDENDS_SET_SELECTED_ACCOUNTS';

/**
 * Action creators
 */
export function fetch(symbols, quantities, accounts = []) {
  return (dispatch) => {
    dispatch({ type: DIVIDENDS_REQUEST });

    return dispatch(
      request('post', '/portfolio/dividends/', {
        body: {
          symbols: toCommaString(symbols),
          quantities: toCommaString(quantities),
        },
      })
    ).then(
      (data) => {
        dispatch({
          type: DIVIDENDS_FETCH_SUCCESS,
          data,
          accounts,
        });
        return data;
      },
      (error) => {
        dispatch({ type: DIVIDENDS_FETCH_FAIL });

        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
  };
}

export function clear() {
  return { type: DIVIDENDS_CLEAR };
}

export function setSelectedAccounts(accountIds) {
  return {
    type: DIVIDENDS_SET_SELECTED_ACCOUNTS,
    accounts: accountIds,
  };
}

/**
 * Helper Functions
 */
function toCommaString(value) {
  return Array.isArray(value) ? value.join(',') : value;
}

function parseErr(err) {
  if (err.non_field_errors) {
    return err.non_field_errors[0];
  }

  return err.msg || err.detail || 'Failed to fetch dividends data.';
}
